import React from 'react';
import { IconProps } from '../types';
const MinecraftLeatherLeggingsOverlay: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="4" y="7" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(149, 94, 59, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(114, 72, 46, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(33, 21, 13, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(149, 94, 59, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(114, 72, 46, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(33, 21, 13, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(114, 72, 46, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(114, 72, 46, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(33, 21, 13, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(114, 72, 46, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(114, 72, 46, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(33, 21, 13, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(52, 33, 21, 255)" />
</svg>);
export default MinecraftLeatherLeggingsOverlay;